import { Box, styled } from '@mui/material'
import { breakpoints } from 'constants/theme'
import { useMatchUrlMarket } from 'hooks/useMatchUrlMarket'
import useWindow from 'hooks/useWindow'
import { memo, useEffect } from 'react'
import { useAppDispatch } from 'store'
import { updateTradeTypeAction } from 'store/market/actions'
import { TradeType } from 'store/market/types'
import { useCurrentSpotSymbol, useSpotSymbols } from 'store/spot/hooks'
import { FlexColumn } from 'styles'
import { useEffectOnce } from 'usehooks-ts'
import { MainWrap } from 'views/Main/styles'
import { Charting } from '../Charting'
import { Balances } from './Balances'
import { CreateOrder } from './CreateOrder'
import { MarketHeader } from './MarketHeader'
import { MobileOrderBookContent } from './MobileOrderBookContent'
import { OrderList } from './OrderList'
import { UserOrders } from './UserOrders'
import { UserGuide } from 'components/UserGuide'
import { AccountAcitveGuide } from 'components/AccountAcitveGuide'
import { AccountActiveDayGuide } from 'components/AccountActiveDayGuide'
import { useAtomValue } from 'jotai'
import { orderbookCollapsed } from 'components/OrderbookCollapsed/atoms'
import clsx from 'clsx'

const { md } = breakpoints.values!
const PcGrid = styled('div')`
  flex: 1;
  display: grid;
  grid-template-areas:
    'market market market orderbook create'
    'chart chart chart orderbook create'
    'orders orders orders orders assets';
  grid-template-columns: 1fr 1fr 1fr 282px 322px;
  grid-template-rows: 68px 1fr 434px;
  gap: 1px;
  background-color: rgba(43, 49, 58, 1);

  &.collapsed {
    grid-template-columns: 1fr 1fr 1fr 0px 322px;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
  }
`
const MobileCol = styled(FlexColumn)<{ $isShowTip?: boolean }>`
  display: none;
  position: relative;
  padding-top: ${({ $isShowTip }) => ($isShowTip ? '55px' : '')};
  padding-bottom: 64px;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
  }
`

export const SpotView = memo(() => {
  const dispatch = useAppDispatch()
  const { innerWidth } = useWindow()
  // const GUIDE_SPOT = localStorage.getItem('zkex_v3_guide_spot')

  const isCollapsed = useAtomValue(orderbookCollapsed)

  useEffectOnce(() => {
    dispatch(updateTradeTypeAction(TradeType.Spot))
  })

  useEffect(() => {
    return () => {
      dispatch(updateTradeTypeAction(TradeType.None))
    }
  }, [dispatch])

  const symbols = useSpotSymbols()
  const currentSymbol = useCurrentSpotSymbol()

  useMatchUrlMarket(symbols, currentSymbol, TradeType.Spot)

  return (
    <MainWrap id="zk_spot_wrap">
      {innerWidth >= md ? (
        <>
          <PcGrid className={clsx({ collapsed: isCollapsed })}>
            <Box sx={{ gridArea: 'market' }}>
              <MarketHeader />
            </Box>
            <Box sx={{ gridArea: 'chart' }}>
              <Charting />
            </Box>
            <Box sx={{ gridArea: 'orderbook', overflow: 'hidden' }}>
              <OrderList />
            </Box>
            <Box sx={{ gridArea: 'orders' }}>
              <UserOrders />
            </Box>
            {/* <Box sx={{ gridArea: 'trades' }}>
              <SpotRecentTrades />
            </Box> */}
            <Box sx={{ gridArea: 'create' }}>
              <CreateOrder />
            </Box>
            <Box sx={{ gridArea: 'assets' }}>
              <Balances />
            </Box>
          </PcGrid>
          <UserGuide />
          <AccountAcitveGuide />
          <AccountActiveDayGuide />
        </>
      ) : (
        <MobileCol>
          <MarketHeader />
          <MobileOrderBookContent></MobileOrderBookContent>
          <UserOrders />
        </MobileCol>
      )}
    </MainWrap>
  )
})
